import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.white};
  position: relative;
  overflow: hidden;
`

export const ContentBox = styled.div`
  margin: auto;
  max-width: ${em(525)};
  padding: 0 ${p => p.theme.indents.baseIndentXs} ${em(70)};
  position: relative;
  text-align: center;
  z-index: 2;

  ${p => p.theme.mq.upMd} {
    padding: 0 0 ${em(60)};
  }
`

export const IconBox = styled.div`
  width: ${em(81)};
  height: ${em(83)};
  margin: 0 auto ${em(20)};
`

export const ImageBox = styled.div`
  position: absolute;
  width: 100%;
`

export const Spacer = styled.div`
  width: 100%;
  height: 0;
  padding-top: 50.625%;

  ${p => p.theme.mq.upMd} {
    padding-top: 33.3333333%;
  }

  ${p => p.theme.mq.upLg} {
    padding-top: 20.78125%;
  }
`

export const HeaderBox = styled.div`
  margin-bottom: ${em(23)};
`
